export default __webpack_public_path__ + "static/media/home-photography-img-03.b78311ba.jpg";